import { trans } from 'laravel-vue-i18n';

/**
 * A very quick and basic implementation of field validation. Used as a placeholder.
 * Could be extended later on with a library like https://www.npmjs.com/package/Validator
 */
export default class QuestionValidator
{
    isValid(questionObject, answer)
    {
        switch (questionObject.question_type) {
            case "radio":
                return this.validateRadio(questionObject, answer);
            case "checkboxes":
                return this.validateCheckboxes(questionObject, answer);
            case "open":
                return this.validateOpen(questionObject, answer);
            case "email":
                return this.validateEmail(questionObject, answer);
        }

        return this.result(true);
    }

    validateRadio(questionObject, answer)
    {
        if (!questionObject.required) {
            return this.result(true);
        }
        return this.result(answer !== null, trans('Kies een optie'));
    }

    validateCheckboxes(questionObject, answer)
    {
        if (!questionObject.required) {
            return this.result(true);
        }

        return this.result(answer !== null && Array.isArray(answer) && answer.length > 0, trans('Kies minimaal één optie'));
    }


    validateOpen(questionObject, answer)
    {
        if (!questionObject.required) {
            return this.result(true);
        }

        return this.result(answer !== null && answer.length >= 2, trans('Veld moet minimaal twee tekens zijn'));
    }

    validateEmail(questionObject, answer)
    {
        if (!questionObject.required && !answer) {
            return this.result(true);
        }
        // Attribution: community wiki @ Stack Overflow
        let regex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/

        let valid = regex.test(String(answer).toLowerCase());

        return this.result(valid, trans('Veld moet een geldig E-mailadres zijn'));
    }


    result(valid, message = null)
    {
        return {
            valid: valid,
            message: message
        }
    }
}
